// src/components/MaintenanceGate.jsx
import React, { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/firebase.jsx";
import { useAuth } from "../context/AuthContext.jsx";
import MaintenancePage from "../pages/MaintenancePage.jsx";

const DEFAULTS = {
  claimingEnabled: false,
  debugMode: false,
  maintenanceMode: false,
};

function getRoutePath() {
  if (typeof window === "undefined") return "/";

  // Supports HashRouter: http://host/#/admin or http://host/#/auth
  const hash = window.location.hash || "";
  if (hash.startsWith("#/")) return hash.slice(1); // "/admin/..." or "/auth"

  // BrowserRouter: http://host/admin or http://host/auth
  return window.location.pathname || "/";
}

export default function MaintenanceGate({ children }) {
  const { primaryRole, roles = [] } = useAuth() || {};
  const isAdmin = primaryRole === "admin" || roles.includes("admin");

  const [settings, setSettings] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const settingsRef = doc(db, "systemSettings", "global");

    const unsub = onSnapshot(
      settingsRef,
      (snap) => {
        if (snap.exists()) {
          setSettings({ ...DEFAULTS, ...snap.data() });
        } else {
          setSettings(DEFAULTS);
        }
        setLoading(false);
      },
      (err) => {
        console.error("[MaintenanceGate] snapshot error:", err);
        setLoading(false);
      }
    );

    return () => unsub();
  }, []);

  // While loading settings, show a simple loader
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500">
        Cargando…
      </div>
    );
  }

  const path = getRoutePath();

  // Allow these routes during maintenance so admins can log in and reach admin tools.
  // IMPORTANT: Your login route is /auth (from your routes.jsx).
  const allowDuringMaintenance =
    path.startsWith("/admin") ||
    path === "/auth" ||
    path.startsWith("/auth") ||
    path === "/login" ||
    path === "/register";

  // Maintenance ON:
  // - allow /auth so you can log in
  // - allow /admin subtree (still protected by AdminRoute / RoleProtectedRoute)
  // - everyone else sees maintenance unless already admin
  if (settings.maintenanceMode) {
    if (allowDuringMaintenance) return <>{children}</>;
    if (!isAdmin) return <MaintenancePage />;
  }

  // Normal case
  return <>{children}</>;
}
